__turbopack_context__.v({
  "errorContainer": "ErrorAPI-module__MBHY8q__errorContainer",
  "errorContainerLandscape": "ErrorAPI-module__MBHY8q__errorContainerLandscape",
});
